import React, { Fragment } from 'react';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  Avatar,
  Box,
  colors,
  Grid,
  makeStyles,
  Tooltip,
  IconButton,
  Typography,
  Chip,
  Paper,
  Link
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';

import { AiOutlineDownload } from "react-icons/ai";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  avatar: {
    marginRight: theme.spacing(1),
    backgroundColor: colors.common.white
  },
  container: {
    height: 535,
    maxHeight: 535
  },
  imgviewer1: {
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: colors.cyan[300],
    width: 280,
    height: 400,
    maxWidth: 280,
    maxHeight: 400
  },
  avatar1: {
    color: colors.cyan[300],
    backgroundColor: colors.green[50],
    border: `1px dashed ${colors.green[200]}`,
    padding: 2,
    width: 280,
    height: 400,
    maxWidth: 280,
    maxHeight: 400,
    textAlign: 'center'
  },
  imgviewer2: {
    marginTop: theme.spacing(2),
    color: colors.cyan[300],
    width: 200,
    height: 440,
    maxWidth: 200,
    maxHeight: 440,
    minHeight: 440
  },
  avatar2: {
    color: colors.cyan[300],
    backgroundColor: colors.green[50],
    border: `1px dashed ${colors.green[200]}`,
    width: 200,
    height: 440,
    maxHeight: 440
  },
  doctitle1: {
    letterSpacing: '-0.05px',
    backgroundColor: colors.green[300],
    color: colors.common.black,
    marginBottom: -5
  },
  doctitle2: {
    letterSpacing: '-0.05px',
    paddingRight: 15,
    paddingLeft: 5,
    color: colors.blue[800]
  }
}));

const formatDateTime = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm')
  } else {
    return 'Não Informada'
  }
}

const fileSize = (bytes) => {
  var exp = Math.log(bytes) / Math.log(1024) | 0;
  var result = (bytes / Math.pow(1024, exp)).toFixed(2);
  return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
}

var tipos = [
  { id: "ARTIE", name: "ART de Iluminação de Emergência" },
  { id: "ARTE", name: "ART Elétrica" },
  { id: "ARTH", name: "ART Hidraulica" },
  { id: "Foto", name: "Foto" },
  { id: "Imagem", name: "Imagem" },
  { id: "LE", name: "Laudo de Elétrica" },
  { id: "LH", name: "Laudo de Hidraulica" },
  { id: "LIE", name: "Laudo de Iluminação de Emergência" },
  { id: "LSPDA", name: "Laudo de SPDA" },
  { id: "Outros", name: "Outros" }
];

const getName = (tipo) => {
  var index = 0;
  for (let index = 0; index < tipos.length; index++) {
    const element = tipos[index];
    if (element.id == tipo) {
      return tipos[index].name;
    }
  }
}

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const openFile = (item) => {

}

const Documents = ({ documents, openDocumentEdition, openDeletionDocument, openUpload, values, disableEdition, selectedMode }) => {

  const classes = useStyles();

  return (
    <Fragment>

      <Box component={PerfectScrollbar} className={classes.container} padding={2}>

        <Grid
          container
          spacing={2}
        >
          {documents.map((item) => (

            <Grid
              item
              md={2}
              xs={12}
            >

              <Grid
                container
                alignItems="center"
                spacing={1}
                component={Paper}
              >
                <Grid
                  item
                  md={12}
                  xs={12}>
                  {(item.descricao == 'Novo Documento') ?
                    (
                      <Tooltip title={`Enviado: ` + moment(item.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                        <Chip disabled={disableEdition} component={Link} onClick={() => { openDocumentEdition(item) }} className={classes.doctitle1} label={item.descricao} variant="outlined" size='small' >
                        </Chip>
                      </Tooltip>
                    ) : (
                      <Tooltip title={`Enviado :` + moment(item.dataEnvio).format('DD/MM/yyyy HH:mm')}>
                        <Link onClick={() => { (!disableEdition) ? openDocumentEdition(item) : {} }}>
                          <Typography
                            className={classes.doctitle2}
                            noWrap
                            variant='h6'>
                            {(item.descricao) ? item.descricao : "Novo Documento"}
                          </Typography>
                        </Link>
                      </Tooltip>
                    )}
                </Grid>

                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <Tooltip title={item.nome + ` - ` + fileSize(item.tamanho)}>
                    <Box className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.imgviewer2 : classes.imgviewer1} >
                      <object data={process.env.REACT_APP_REMOTE_REPO + '/units/' + item.unidade + '/' + item.nome}
                        type={item.formato}
                        className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}
                        style={{ objectFit: 'contain', height: '100%' }}
                        onClick={() => { openFile(item) }} />
                    </Box>
                  </Tooltip>
                </Grid>

                <Grid
                  item
                  md={2}
                  xs={3}>
                  <Tooltip title="Editar documento">
                    <IconButton
                      disabled={disableEdition}
                      color="secondary"
                      children={<EditRoundedIcon />}
                      size="medium"
                      onClick={() => { openDocumentEdition(item) }}></IconButton>
                  </Tooltip>
                </Grid>

                <Grid
                  item
                  md={2}
                  xs={3}>
                  <Tooltip title="Excluir documento">
                    <IconButton
                      disabled={disableEdition}
                      color="secondary"
                      children={<DeleteRoundedIcon />}
                      size="medium"
                      onClick={() => { openDeletionDocument(item) }}></IconButton>
                  </Tooltip>
                </Grid>

                <Grid
                  item
                  md={2}
                  xs={3}>
                  <Tooltip title="Baixar documento">
                    <IconButton
                      disabled={disableEdition}
                      color="secondary"
                      target="_blank"
                      children={<AiOutlineDownload />}
                      size="medium"
                      href={process.env.REACT_APP_REMOTE_REPO + '/units/' + item.unidade + '/' + item.nome}>
                    </IconButton>
                  </Tooltip>
                </Grid>

                <Grid
                  item
                  md={6}
                  xs={12}>

                  <Link onClick={() => { (!disableEdition) ? openDocumentEdition(item) : {} }}>
                    <Typography
                      color='secondary'
                      variant='h6'>
                      {(item.tipo) ? getName(item.tipo) : "Tipo Não Informado"}
                    </Typography>
                  </Link>
                </Grid>

              </Grid>

            </Grid>

          ))}

          {(documents.length == 0) ? (
            <Grid
              item
              md={2}
              xs={12} >

              <Box className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.imgviewer2 : classes.imgviewer1}
                component={IconButton}
                onClick={() => { openUpload(values) }}
              >
                <Avatar variant='rounded' className={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? classes.avatar2 : classes.avatar1}>
                  Sem Imagem
                </Avatar>
              </Box>
            </Grid>
          ) : ("")}

        </Grid>

      </Box>

    </Fragment>
  )
}

export default Documents;
